import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SearchBackofficeOrganizationsSchema } from "./list"

export const Route = createFileRoute("/_base/_auth/backoffice/organizations/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Navigate
      to="/backoffice/organizations/list"
      search={SearchBackofficeOrganizationsSchema.parse({})}
      replace
    />
  )
}
